export default "__VITE_ASSET__e72fcb10__"